import React from 'react';
import PropTypes from 'prop-types';
import Card from 'src/components/Cards/Card';
import AvatarImage from 'shared/components/avatar-image';
import AcceptButton from './accept-button';
import RejectButton from './reject-button';

const propTypes = {
  acceptConnection: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.string,
  rejectConnection: PropTypes.func.isRequired,
  removeConnection: PropTypes.func.isRequired,
  type: PropTypes.string,
};

const textForStatus = (status) => {
  switch (status) {
    case 'pending':
      return 'Pending connection approval';
    case 'accepted':
      return 'Connected!';
    case 'rejected':
      return 'Rejected';
    case null:
    default:
      return '';
  }
};

const ConnectionInformationCard = ({
  status,
  acceptConnection,
  image,
  displayName,
  firstName,
  lastName,
  type,
  id,
  rejectConnection,
  removeConnection,
}) => (
  <Card className="connection-information-card">
    <div className="row connection-information-card-container">
      <div className="col-sm-1 col-xs-2">
        <AvatarImage userInfo={{firstName, lastName, image}} />
      </div>
      <div className="col-sm-4 col-xs-6 connection-information-card-content">
        <div className="connection-information-card-name">{displayName}</div>
        <div className="connection-information-card-type">{type}</div>
      </div>
      <div className="col-sm-3 connection-information-card-status">{textForStatus(status)}</div>
      <div className="col-sm-4 col-xs-4 connection-information-card-button">
        {status === 'accepted' && (
          <RejectButton
            label="Remove Connection"
            displayName={displayName}
            id={id}
            rejectConnection={removeConnection}
          />
        )}
        {status === 'pending' && (
          <>
            <AcceptButton displayName={displayName} id={id} acceptConnection={acceptConnection} />
            <RejectButton
              label="Reject"
              displayName={displayName}
              id={id}
              rejectConnection={rejectConnection}
            />
          </>
        )}
        {status === 'rejected' && (
          <AcceptButton displayName={displayName} id={id} acceptConnection={acceptConnection} />
        )}
      </div>
    </div>
  </Card>
);

ConnectionInformationCard.propTypes = propTypes;

export default ConnectionInformationCard;
